<template>
  <div class="outer-action-card-container">
    <div
      class="action-card-container"
      :class="{ 'flash-border': flashBorder }"
      @click.stop.prevent="cardClicked"
      v-ripple
    >
      <div class="action-name">
        <!--[{{ setIndex }}, {{ actionIndex }}]: -->
        {{ actionName }}
      </div>

      <template v-if="state != 'unlocked'">
        <HeightSwitcher :unlocked="state == 'revealed'" @switched="switched">
          <template v-slot:first>
            <div class="locked-content-outer">
              <div class="locked-content">
                <svg width="3rem" height="3rem" viewBox="0 0 24 24">
                  <path :d="mdiLock" fill="#FF3633" />
                </svg>
                <span class="lock-text red">Find me</span>
              </div>
              <div class="unlock-amount-text">
                Discover for {{ creditCost }}
                {{ creditCost > 1 ? 'credits' : 'credit' }}
              </div>
            </div>
          </template>
          <template v-slot:second>
            <div class="unlocked-content-outer">
              <div class="unlocked-content">
                <svg width="3rem" height="3rem" viewBox="0 0 24 24">
                  <path :d="mdiHelpCircle" fill="#E0A800" />
                </svg>
                <span class="lock-text yellow">Click to reveal</span>
              </div>
            </div>
          </template>
        </HeightSwitcher>
      </template>
      <template v-else>
        <div class="unlocked-content-outer">
          <div class="unlocked-content">
            <svg width="3rem" height="3rem" viewBox="0 0 24 24">
              <path :d="mdiCheckCircle" fill="#468B18" />
            </svg>
            <span class="lock-text green">Discovered</span>
          </div>
        </div>
      </template>
      <!--<div class="code-container">
        <div class="lock">
          <svg width="3rem" height="3rem" viewBox="0 0 24 24">
            <path :d="mdiLock" fill="#FF3633" />
          </svg>
          <span class="lock-text">Locked</span>
        </div>
        <div
          v-for="i in 9"
          :id="`button-${i}`"
          :ref="i"
          :key="i"
          class="code-button noSelect"
        >
          {{ i }}
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import HeightSwitcher from '@/components/HeightSwitcher.vue'
import { mdiLock, mdiCheckCircle, mdiHelpCircle } from '@mdi/js'

export default {
  name: 'ActionCard',
  components: { HeightSwitcher },
  props: {
    number: Number,
    actionKey: String,
    topSentinel: { type: Boolean, default: false },
    bottomSentinel: { type: Boolean, default: false },
  },
  data() {
    return {
      mdiLock,
      mdiCheckCircle,
      mdiHelpCircle,
      // green, red, blue,
      stages: ['green', 'red', 'blue'],
      backgroundColors: ['#002228', '#541218', '#0F1D57'],
      darkerBackgroundColors: [
        'rgb(0,20,23)',
        'rgb(51, 11, 15)',
        'rgb(7, 14, 41)',
      ],
      flashBorder: false,
      //unlocked: false,
    }
  },
  /*mounted() {
    this.unlocked = this.unlockedMaster
  },*/
  computed: {
    state() {
      if (this.$store.getters.isActionUnlocked(this.actionKey)) {
        return 'unlocked'
      } else if (this.$store.getters.isActionRevealed(this.actionKey)) {
        return 'revealed'
      } else {
        return 'locked'
      }
    },
    unlocked() {
      return this.$store.getters.isActionUnlocked(this.actionKey)
    },
    /*unlockedMaster() {
      return this.$store.getters.isActionUnlocked(this.actionKey)
    },*/
    actionName() {
      return this.$store.getters.actions[this.actionKey]
    },
    creditCost() {
      return this.$store.getters.creditCosts[this.actionKey]
    },
  },
  methods: {
    cardClicked() {
      this.flashBorder = false
      this.$emit('click')
    },
    switched() {
      this.flashBorder = true
    },
  },
  /*watch: {
    unlockedMaster(new_val, old_val) {
      if (new_val && !old_val) {
        console.log(this.actionKey, ' just unlocked')
        this.flashBorder = true
        this.unlocked = true
      }
    },
  },*/
}
</script>

<style scoped>
.outer-action-card-container {
  width: 100%;
  padding-top: 2rem;
}

.action-card-container {
  width: 90%;
  max-width: 30rem;
  border: 1px solid #cdf4dd;
  /*border: 1px solid #ff3633;*/
  box-sizing: border-box;
  border-radius: 0.5rem;
  font-family: 'Montserrat', sans-serif;
  color: #cdf4dd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  /*background-color: rgba(3, 28, 33, 0.8);*/
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}

.flash-border {
  animation-name: flash-border-animation;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes flash-border-animation {
  /*from {
    border: 1px solid #cdf4dd;
  }
  to {
    border: 1px solid yellow;
  }*/
  from {
    background-color: rgba(0, 0, 0, 0.4);
  }
  to {
    background-color: rgba(179, 150, 57, 0.2);
  }
}

.action-background {
  width: 100%;
  /*padding-bottom: 2rem;*/
  /*background-color: rgba(0, 34, 40, 1);*/
}

.margin-block > svg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  transform: translate(0, -1.5px);
  width: 5.5rem;
  height: 5.5rem;
}

.margin-block-normal {
  width: 100%;
  height: 2rem;
}

.margin-block-transition {
  width: 100%;
  height: 6rem;
}

/*.action-container:first-child {
  margin-top: 5.5rem;
}

.action-container:last-child {
  margin-bottom: 3rem;
}*/

.action-name {
  font-size: 1.5rem;
  font-weight: 300;
  margin-top: 1rem;
  margin-bottom: 1.25rem;
}

.code-container {
  position: relative;
  color: rgb(77, 105, 99);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  row-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  margin-bottom: 1rem;
  /*column-gap: 0.75rem;*/
  /*row-gap: 0.75rem;*/
}

.code-button {
  /*width: 3rem; 
  height: 3rem;*/
  width: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  height: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  border-radius: 50%;
  border: 0.5px solid rgb(77, 105, 99);
  display: flex;
  justify-content: center;
  align-items: center;
  /*font-size: 2rem;*/
  font-size: calc(clamp(1rem, 8.8vmin, 2.5rem) / 1.5);
  font-family: 'Open Sans';
  font-weight: 100;
  cursor: pointer;
  user-select: none;
}

.locked-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 1rem;
}

.unlocked-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  margin-bottom: 1.5rem;
}

.lock-text.red {
  color: #ff3633;
}

.lock-text.green {
  color: #468b18;
}

.lock-text.yellow {
  color: #e0a800;
}

.lock {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #ff3633;
}

.lock-text {
  font-size: 1.5rem;
  font-weight: 100;
}

.unlock-amount-text {
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 100;
}

.noSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
